import { appReleaseFormModel, featureFormModel } from './appReleaseFormModel';

const {
    formField: {
        version,
        application,
        features,
        type
    }
} = appReleaseFormModel;

export default {
    [version.name]: '',
    [application.name]: '',
    [type.name]: '',
    [features.name]: [
        {
            [featureFormModel.moduleName.name]: '',
            [featureFormModel.title.name]: '',
            [featureFormModel.description.name]: '',
            [featureFormModel.type.name]: ''
        }
    ]
};
